import { createAction, handleActions } from 'redux-actions';
import http from '../../utility/http';
import { prepareNotifications } from '../../utility/globalNotifications';
import {
  API_NOTIFICATIONS,
  API_NOTIFICATIONS_COUNT,
  API_CLEAR_NOTIFICATIONS,
  api_clear_notification,
} from '../../constants/apiRoutes';

// ------------------------------------
// Constants
// ------------------------------------

const SET_NOTIFICATIONS_COUNT = 'SET_NOTIFICATIONS_COUNT';
const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
const CLEAR_NOTIFICATION_ITEMS = 'CLEAR_NOTIFICATION_ITEMS';
const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';

const initialState = {
  count: 0,
  items: [],
};

// ------------------------------------
// Actions
// ------------------------------------

const setNotificationsCount = createAction(SET_NOTIFICATIONS_COUNT);
const setNotifications = createAction(SET_NOTIFICATIONS);
const removeNotification = createAction(REMOVE_NOTIFICATION);
const clearNotificationItems = createAction(CLEAR_NOTIFICATION_ITEMS);
const clearNotifications = createAction(CLEAR_NOTIFICATIONS);

// ------------------------------------
// Reducers
// ------------------------------------

const reducers = {
  [SET_NOTIFICATIONS_COUNT]: (state, { payload }) => ({
    ...state,
    count: payload,
  }),
  [SET_NOTIFICATIONS]: (state, { payload }) => ({
    ...state,
    items: payload,
    ...(payload.length !== state.count ? { count: payload.length } : {}),
  }),
  [REMOVE_NOTIFICATION]: (state, { payload }) => ({
    ...state,
    count: state.count > 0 ? state.count - 1 : 0,
    items: state.items.filter(notification => notification.id !== payload),
  }),
  [CLEAR_NOTIFICATION_ITEMS]: state => ({
    ...state,
    items: [],
  }),
  [CLEAR_NOTIFICATIONS]: () => initialState,
};

// ------------------------------------
// API calls
// ------------------------------------

const getNotificationsCountValue = data => {
  if (typeof data === 'number') return data;

  return Number(data?.count) || 0;
};

export const getNotificationsCount = dispatch => {
  return http.get(API_NOTIFICATIONS_COUNT).then(({ data }) => {
    return dispatch(setNotificationsCount(getNotificationsCountValue(data)));
  });
};

export const getNotifications = (
  dispatch,
  canAccessUserProfileCheck,
  canAccessDetailsCheck
) => {
  return http.get(API_NOTIFICATIONS).then(({ data }) => {
    const items = prepareNotifications(
      data,
      canAccessUserProfileCheck,
      canAccessDetailsCheck
    );

    dispatch(setNotifications(items));

    return { data: items };
  });
};

export const onClearNotification = (dispatch, notificationId) => {
  return http.post(api_clear_notification(notificationId)).then(() => {
    dispatch(removeNotification(notificationId));
  });
};

export const onClearAllNotifications = dispatch => {
  return http.post(API_CLEAR_NOTIFICATIONS).then(() => {
    dispatch(clearNotifications());
  });
};

export default handleActions(reducers, initialState);

export { clearNotifications, clearNotificationItems };
